import * as THREE from 'three';
import { TrackballControls } from './trackball.js';
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer.js';
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { BraidArrangement, Hyperplane, WeightVector } from './geometry.js';
import { Colors } from './colors.js';
import './css/tailwind/before.css';
import './css/style.css';
import './css/tailwind/after.css';


function animate() {
    requestAnimationFrame(animate);
    controls.update();
    render();
}


function render() {
	renderer.render( scene, camera );
    labelRenderer.render( scene, camera );
}


window.addEventListener('resize', () => {
    // camera.aspect = window.innerWidth / window.innerHeight;
    // renderer.setSize(window.innerWidth, window.innerHeight);
    // // renderer.setPixelRatio( window.devicePixelRatio );
    // camera.updateProjectionMatrix();
    const height = container.clientHeight; // Math.min(canvas.clientHeight, window.innerHeight);
    const width = container.clientWidth; //Math.min(canvas.clientWidth, window.innerWidth);
    renderer.setSize(width, height);
    labelRenderer.setSize(width, height);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
});


function onMouseMove( event ) {

    mouse.x = ( event.clientX  / ( window.innerWidth ) ) * 2 - 1;
    mouse.y = - ( event.clientY  / ( window.innerHeight ) ) * 2 + 1;

    const origin = new THREE.Vector3(0, 0, 0);
    const dist = origin.distanceTo(camera.position);
    const x = mouse.x * dist;
    const y = mouse.y * dist;
    let position = new THREE.Vector3();
    position.x = x;
    position.y = y;
    position.z = 0;

    if (selected != null) {

        const xrad = mouse.x * Math.PI / 2;
        const yrad = mouse.y * Math.PI / 2;

        let target = new THREE.Vector3();

        camera.getWorldDirection(target);

        let zaxis = new THREE.Vector3(0, 0, -1);

        const rotation = new THREE.Quaternion();

        rotation.setFromUnitVectors( zaxis, target.normalize());

        // Project onto sphere
        const rad = 3.;
        position.x = rad * Math.sin(xrad);
        position.y = rad * Math.cos(xrad) * Math.sin(yrad);
        position.z = rad * Math.cos(xrad) * Math.cos(yrad);
        //rho * math.cos(latitude) * math.cos(longitude),
        //rho * math.cos(latitude) * math.sin(longitude),
        //rho * math.sin(latitude)
            
        // Compute position on hemisphere (imagine a dome)
        position.applyQuaternion(rotation);

        selected.move_to(position);

        plane.disposeIntersections();
        for (let h of arrangement.hyperplanes) {
            plane.intersectPlane(h);
        }


        // controls.object.position.set(...position.addScalar(10).toArray());
        // controls.object.up = new THREE.Vector3(0,0,1);
        // controls.target.set(...position.negate().multiplyScalar(2).toArray());
        // controls.update();
        position = position.normalize();
        plane.lookAt(position);


        for (let c of arrangement.object.children) {
            let neg = plane.plane.clone().negate();
            c.material.clippingPlanes[0] = neg;
        }

        // Update where Columnspace label appears
        label.position.set(...plane.pointA().toArray());

        // var dir = new THREE.Vector3( 0, 0, 1 );
        // dir.applyQuaternion( plane.quaternion );
        //
        // var quaternion = new THREE.Quaternion(); // create one and reuse it
        // quaternion.setFromUnitVectors( dir, position );
        //
        // plane.translateOnAxis(dir, -bias);
        // plane.applyQuaternion(quaternion);
        // plane.translateOnAxis(position, bias);

        // let norm = dir.length();
        // console.log(plane.position);
        // plane.lookAt(position);
        // plane.translateOnAxis(position, +bias);
    }
}

function onMouseDown( event ) {
    if (event.which === 1) {
        selected = wv.pick(mouse, scene, camera);
    }
    else if (event.which === 2) {
        arrangement2.object.visible = true;
    }
}

function onMouseUp( event ) {
    selected = null;
    arrangement2.object.visible = false;
}


const canvas = document.getElementById('canvas');
const container = document.getElementById('container');

const mouse = new THREE.Vector2();
let selected = null;

const renderer = new THREE.WebGLRenderer({canvas, antialias: true});
renderer.setClearColor("#ffffff");
renderer.setSize(canvas.clientWidth, canvas.clientHeight);
renderer.setPixelRatio( window.devicePixelRatio );
renderer.localClippingEnabled = true;

container.appendChild(renderer.domElement);

let	labelRenderer = new CSS2DRenderer(renderer.domElement);
labelRenderer.setSize( canvas.clientWidth, canvas.clientHeight );
labelRenderer.domElement.style.position = 'absolute';
labelRenderer.domElement.style.top = '0px';
labelRenderer.domElement.style.pointerEvents = 'none';

container.appendChild(labelRenderer.domElement);


const camera = new THREE.PerspectiveCamera( 50, window.innerWidth / window.innerHeight, .1, 2000 );
const campos = [5.5, 5.5, 4];
// const campos = [-4, 2., 4.8];
camera.position.set(...campos);
camera.lookAt(new THREE.Vector3(0, 0, 0));

// const controls = new OrbitControls(camera, renderer.domElement);
const controls = new TrackballControls(camera, renderer.domElement);

const scene = new THREE.Scene();

const ambientLight = new THREE.AmbientLight( 0xd1d1d1 );
scene.add( ambientLight );

// const bias  = -.4;
const bias  = 0;
let dir = new THREE.Vector3(-1.1, 1.2, 1.4);
// let plane_clip_neg = new THREE.Plane( new THREE.Vector3(-1, 0, 0), -bias + epsilon);

let plane = new Hyperplane(dir.x, dir.y, dir.z, bias, 0xffffff, 6, 6, .95);
plane.object.renderOrder = 1;
plane.material.depthWrite = false;

const text = document.createElement( 'div' );
text.className = 'w-label';
// const rep = this.rep_obj();
// text.style.color = '#' + rep.material.color.getHexString();
// text.textContent = 'Input Space';
text.textContent = 'Columnspace of W';

let label = new CSS2DObject( text );
label.position.set(...plane.pointA().toArray());
scene.add(label);
// rep.getWorldPosition(this.label.position);

// const box = new THREE.Box3();
// box.copy(plane.geometry.boundingBox);
// console.log(plane_clip.intersectsBox(box));

console.log(plane.geometry);
let arrangement = new BraidArrangement();
for (let c of arrangement.object.children) {
    let cut = plane.plane.clone().negate();
    c.material.clippingPlanes = [cut];
}
scene.add( arrangement.object );


for (let h of arrangement.hyperplanes) {
    plane.intersectPlane(h);
}


// TODO: Show this on rotation
let arrangement2 = new BraidArrangement(.1);
for (let c of arrangement2.object.children) {
    // c.material.side = THREE.BackSide;
    c.material.depthWrite = false;
    c.material.clippingPlanes = [plane.plane];
}
arrangement2.object.renderOrder = 2;
arrangement2.object.visible = false;
scene.add( arrangement2.object );


scene.add( plane.object );

let wv = new WeightVector(dir.x, dir.y, dir.z, 0x222222, 'Nullspace');

scene.add( wv.group );

window.addEventListener( 'pointerup', onMouseUp );
window.addEventListener( 'pointerdown', onMouseDown );
window.addEventListener( 'pointermove', onMouseMove );

// label.visible = false;
// wv.group.visible = false;
// wv.label.visible = false;
// arrangement.object.visible = false;
// camera.position.set(...dir.clone().multiplyScalar(4.).toArray())

// Followup plots
camera.position.set(7., 3.54, 5.1);
// plane.object.visible = false;

animate();
